export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./payments.vue?vue&type=template&id=09acbe31&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/kra/payments.vue?vue&type=template&id=09acbe31&scoped=true
// module id = X+Nk
// module chunks = 0